const workExp = [
  {
    year: "MAR 2023",
    achievement: "Joined 'Sartha' as a Full-stack Developer Intern",
    brief:
      "Built Sartha.in from scratch with authentication, payment gateway and admin panel. Achieved 200% ROI within 2 months of launch.",
  },
  {
    year: "OCT 2023",
    achievement: "Worked for AIIMS GKP as a Solo Freelancer",
    brief:
      "Developed website for AIIMS GKP annual fest with QR-based entry system for efficient event registration and pass management.",
  },
  {
    year: "DEC 2024",
    achievement: "Built 'Bright Academy' mobile app",
    brief:
      "Created a cross-platform mobile app with React Native for a coaching institute for study material and student management.",
  },
  {
    year: "Present",
    achievement: "Looking for SDE/SWE internships",
    brief:
      "Currently seeking internship opportunities in Software Development roles to enhance my skills and gain practical experience in the field.",
  },
];

module.exports = { workExp };
